import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import { forwardRef } from 'react';
import ChevronIcon from '../../assets/icons/chevron.svg';
import { useTranslation } from 'react-i18next';
import Input from '../Input';
import { updateTaskAnswer, updateTaskAnswerTranslation, validateAnswers, } from '../../forms/AdminContentForms/adminTask/SelectionTask/helpers';
import Checkbox from '../Checkbox';
import TranslatedFieldsRow from '../../modules/TranslationsFieldsRow';
import RemoveIcon from '../../assets/icons/close.svg';
import Button from '../Button';
import { isNotEmpty } from '../../hooks/formValidator/validators';
const AdminTaskAnswerCard = forwardRef(({ disableUp, disableDown, moveAnswer, taskAnswer, taskIndex, formState, formErrors, validateInputField, setAnswersError, setUpdatedFormFields, onDeleteAnswer, }, ref) => {
    const { t, i18n } = useTranslation();
    const onAnswerTranslationsChange = (lang, value) => {
        updateTaskAnswerTranslation({
            formState,
            id: taskAnswer.clientId,
            lang,
            value,
        });
        validateInputField({
            fieldName: `answerContent${taskIndex + 1}${lang.toUpperCase()}`,
            value,
            customInputSchema: {
                [`answerContent${taskIndex + 1}${lang.toUpperCase()}`]: [isNotEmpty],
            },
        });
        setUpdatedFormFields((prev) => {
            const newSet = new Set(prev);
            newSet.add('taskAnswers');
            return newSet;
        });
    };
    return (_jsxs("div", { className: "task-answer-item selection-task", ref: ref, children: [_jsxs("div", { className: "task-answer-item-header", children: [_jsxs("div", { className: "task-answer-order-controls", children: [_jsx("div", { className: "task-answer-order", children: _jsx("span", { children: taskIndex + 1 }) }), _jsxs("div", { className: "order-arrows", children: [_jsx("button", { className: "order-arrow arrow-up", onClick: () => moveAnswer('up'), disabled: disableUp, children: _jsx(ChevronIcon, {}) }), _jsx("button", { className: "order-arrow arrow-down", onClick: () => moveAnswer('down'), disabled: disableDown, children: _jsx(ChevronIcon, {}) })] })] }), _jsx(Input, { color: 'gray', id: `answer-content-${taskIndex + 1}`, value: taskAnswer.translations[i18n.language], name: `answerContent${taskIndex + 1}${i18n.language.toUpperCase()}`, placeholder: `${t('placeholder.answer')} ${taskIndex + 1}`, onChange: (event) => {
                            updateTaskAnswerTranslation({
                                formState,
                                id: taskAnswer.clientId,
                                lang: i18n.language,
                                value: event.currentTarget.value,
                            });
                            validateInputField({
                                fieldName: `answerContent${taskIndex + 1}${i18n.language.toUpperCase()}`,
                                value: event.currentTarget.value,
                                customInputSchema: {
                                    [`answerContent${taskIndex + 1}${i18n.language.toUpperCase()}`]: [isNotEmpty],
                                },
                            });
                            setUpdatedFormFields((prev) => {
                                const newSet = new Set(prev);
                                newSet.add('taskAnswers');
                                return newSet;
                            });
                        }, additionalContent: _jsxs(_Fragment, { children: [_jsx(Checkbox, { id: `answer-is-correct-${taskIndex + 1}`, label: t('label.is_correct'), onChange: () => {
                                        const newTaskAnswers = updateTaskAnswer({
                                            formState,
                                            field: 'isCorrect',
                                            id: taskAnswer.clientId,
                                            value: !taskAnswer.isCorrect,
                                        });
                                        validateAnswers({
                                            taskType: formState.selectedTaskType,
                                            taskAnswers: newTaskAnswers,
                                            setTaskAnswersError: setAnswersError,
                                        });
                                        setUpdatedFormFields((prev) => {
                                            const newSet = new Set(prev);
                                            newSet.add('taskAnswers');
                                            return newSet;
                                        });
                                    }, checked: taskAnswer.isCorrect, labelColor: '#7c818c' }), _jsx(Button, { shape: 'square', icon: _jsx(RemoveIcon, {}), iconSize: 'small', onClick: () => onDeleteAnswer(taskAnswer.clientId), disabled: formState.taskAnswers.length <= 2 })] }), error: !!formErrors[`answerContent${taskIndex + 1}${i18n.language.toUpperCase()}`]?.length, errorMessage: formErrors[`answerContent${taskIndex + 1}${i18n.language.toUpperCase()}`]?.length
                            ? t(formErrors[`answerContent${taskIndex + 1}${i18n.language.toUpperCase()}`][0]
                                .messageTranslationKey)
                            : undefined })] }), _jsx("div", { className: "form-translations-group", children: _jsx(TranslatedFieldsRow, { fieldName: `answerContent${taskIndex + 1}`, values: taskAnswer.translations, onChange: (lang, value) => onAnswerTranslationsChange(lang, value), formErrors: formErrors, originContent: taskAnswer.translations[i18n.language], placeholder: `${t('placeholder.answer')} ${taskIndex + 1}` }) })] }));
});
export default AdminTaskAnswerCard;
